var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formUrl())?_c('img',{attrs:{"width":"1","height":"1","src":_vm.formUrl()}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }